export const NoMatch = (): React.JSX.Element => <h1>{'404 - Whoopsie'}</h1>;
